module.exports = __webpack_public_path__ + "assets/img/on6-29bd5b0b.png";